<form [formGroup]="workOrderSearchTextForm">
  <div style="display: flex; width: 100%">
    <mc-input-group style="width: 100%" hiddenlegend fit="small">
      <mc-input
        style="width: 100%"
        placeholder="Search by WorkOrder or Equipment Number"
        fit="small"
        ngDefaultControl
        formControlName="searchText"
        hiddenlabel
        [clearbutton]="true"
        (clearbuttonclick)="applySearchTextFilters()"
        [attr.invalid]="isControlInErrorState(this.workOrderSearchTextForm.controls.searchText)"
        (keyup.enter)="applySearchTextFilters()">
        @if (this.workOrderSearchTextForm.controls.searchText.hasError('pattern')) {
          <span slot="errormessage">Incorrect work order or equipment number</span>
        }
      </mc-input>
      <mc-button
        variant="filled"
        (keydown.enter)="applySearchTextFilters()"
        (click)="applySearchTextFilters()"
        appearance="secondary"
        label="search"
        fit="small"
        hiddenlabel
        icon="magnifying-glass"></mc-button>
    </mc-input-group>
  </div>
</form>
